import Main from "../components/find-an-advisor/Index.vue"
import init from "../root_init"
init(Main)
